module.exports = __webpack_public_path__ + "static/scroll_heatmap_landing-a6892f0bfee800849c4179d6447540e8.jpg";